export class MailSentResponse {
  accepted: string[];
  rejected: string[];

  constructor(accepted: string[], rejected: string[]) {
    this.rejected = rejected;
    this.accepted = accepted;
  }
}
